module.exports = __webpack_public_path__ + "static/media/bs_logo.5358b5e4.png";